import React, { Fragment, useState, useEffect } from "react";
import { Row, Button } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import CartaServicoService from "../../../../../../services/cartaServico-auth";
import '../../../../../../styles/diario.scss';

const Carta = () => {
    let { id } = useParams();
    const [servico, setServico] = useState("");
    const [finalidade, setFinalidade] = useState("");
    const [requisitos, setRequisitos] = useState("");
    const [etapas, setEtapas] = useState("");
    const [tempo, setTempo] = useState("");
    const [local, setLocal] = useState("");
    const [secretaria, setSecretaria] = useState("");


    async function fetchCarta(id) {
        const response = await CartaServicoService.cartaEdit(id);
        setServico(response.data["servico"]);
        setRequisitos(response.data["requisitos"]);
        setEtapas(response.data["etapas"]);
        setFinalidade(response.data["finalidade"]);
        setTempo(response.data["tempo"]);
        setLocal(response.data["local"]);
        setSecretaria(response.data["secretaria"]);
    }

    useEffect(() => {
        fetchCarta(id)
    }, [id])

    return (
        <Fragment>
            <Row xs={12}>
                <h5>{secretaria}: {servico}</h5>
                <p>Finalidade: {finalidade}</p>
                <p>Requisitos: {requisitos}</p>
                <p>Etapas: {etapas}</p>
                <p>Tempo/Horários: {tempo}</p>
                <p>Local: {local}</p>
            </Row>
            <Link to={`/restrito/institucional/cartaservico/editar/${id}`}>
                <Button type="button" variant='primary'>Editar</Button>
            </Link>
            <br /><br />
            <Link to={`/restrito/institucional/cartaservico/listar`}>
                <Button type='button' variant='danger'>Voltar</Button>
            </Link>
        </Fragment >)
}

export default Carta;